export default __webpack_public_path__ + "static/media/banner-mobile-bg-blue-template.2f3c9c82.svg";